"use client";
import clsx from "clsx";
import { useApp } from "@/context/AppContext";
import usePageType from "@/hooks/usePageType";
import DesktopNav from "./desktop-nav";
import MobileNav from "./mobile-nav";


export default function Header() {
  const { isRecordPage, isStoryPage, isMapPage} = usePageType();
  const { navLinks, isInitialLoad, isRecordsNavOverlayOpen } = useApp();
  const isOverlayPage = (isRecordPage || isStoryPage || isMapPage || isRecordsNavOverlayOpen);
  const isFixed = isOverlayPage && !isInitialLoad
  const isNotAccessible = isOverlayPage;
  return (
    <header
      className={clsx(
        "main-nav top-0 z-50 w-full h-(--header-height) pointer-events-none",
        isFixed ? 'fixed' : 'sticky'
      )}
      style={{ position: isFixed ? 'fixed' : 'sticky' }}
      {...(isNotAccessible && { inert: true, "aria-hidden": true })}
    >
      <DesktopNav navLinks={navLinks} />
      <MobileNav navLinks={navLinks} />
    </header>
  );
}
